// Load Styles
import '../scss/main.scss';

// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";
import { Application } from "@hotwired/stimulus";
import Carousel from '@stimulus-components/carousel';
import Lightbox from '@stimulus-components/lightbox'

import AnkerController from "../controllers/anker_controller.js";
import PortfolioController from "../controllers/portfolio_controller.js";
import PositionController from "../controllers/position_controller.js";
// import Masonry from 'masonry-layout';

window.Stimulus = Application.start();
Stimulus.register("anker", AnkerController);
Stimulus.register("portfolio", PortfolioController);
Stimulus.register("position", PositionController);
Stimulus.register('carousel', Carousel);
Stimulus.register('lightbox', Lightbox)

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
});

document.addEventListener("DOMContentLoaded", function(){
// make it as accordion for smaller screens
  if (window.innerWidth > 992) {

    document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){

      everyitem.addEventListener('mouseover', function(e){

        let el_link = this.querySelector('a.dropdown-toggle');

        if(el_link != null){
          let nextEl = el_link.nextElementSibling;
          el_link.classList.add('show');
          nextEl.classList.add('show');
        }

      });
      everyitem.addEventListener('mouseleave', function(e){
        let el_link = this.querySelector('a.dropdown-toggle');

        if(el_link != null){
          let nextEl = el_link.nextElementSibling;
          el_link.classList.remove('show');
          nextEl.classList.remove('show');
        }


      });
      everyitem.addEventListener('click', function(e){
        let el_link = this.querySelector('a.dropdown-toggle');
        if(el_link != null){
          let h = el_link.getAttribute('href');
          location.href = h;
        }
      })
    });

  }
// end if innerWidth
});

document.querySelectorAll('[id^="question"]').forEach(function(button, index) {
  button.addEventListener('click', function() {
    var answer = document.getElementById('answer' + (index));
    var arrow = document.getElementById('arrow' + (index));

    document.querySelectorAll('.aco-item').forEach(function(aco, index) {
      aco.classList.remove('closed-accordion');
    });
    document.querySelectorAll('.aco-item').forEach(function(aco, index) {
      aco.classList.add('closed-accordion');
    });

    answer.classList.toggle('closed-accordion');
    answer.scrollIntoView();

  });
});

// YOUTUBE LAZY
let videos = document.querySelectorAll('[data-youtube]');
for (let video of videos) {
  let id = new URL(video.href).searchParams.get('v');
  video.setAttribute('data-youtube', id);
  video.setAttribute('role', 'button');
  video.innerHTML =
    `<div style="position: relative">
<img alt="" src="https://img.youtube.com/vi/${id}/maxresdefault.jpg" style="width: 100%">
<div style="width: 80px; height: 80px; position: absolute; left: calc(50% - 40px); top: calc(50% - 40px)">
<svg height="80px" width="80px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
\t viewBox="0 0 496.158 496.158" xml:space="preserve">
<path style="fill:#E04F5F;" d="M496.158,248.085c0-137.022-111.069-248.082-248.075-248.082C111.07,0.003,0,111.063,0,248.085
\tc0,137.001,111.07,248.07,248.083,248.07C385.089,496.155,496.158,385.086,496.158,248.085z"/>
<path style="fill:#FFFFFF;" d="M404.191,338.019c0,7.498-6.077,13.574-13.573,13.574H105.541c-7.497,0-13.574-6.076-13.574-13.574
\tv-179.88c0-7.498,6.077-13.574,13.574-13.574h285.077c7.496,0,13.573,6.076,13.573,13.574V338.019z"/>
<path style="fill:#E04F5F;" d="M335.494,239.131l-123.131-75.607c-3.361-2.063-7.785-2.154-11.225-0.227
\tc-3.504,1.961-5.682,5.672-5.682,9.687V323.6c0,4.005,2.171,7.715,5.665,9.678c1.654,0.93,3.536,1.421,5.435,1.421
\tc2.039,0,4.036-0.562,5.775-1.62l123.129-75.01c3.277-1.996,5.317-5.621,5.324-9.459
\tC340.792,244.77,338.766,241.138,335.494,239.131z"/>
</svg>
</div>
</div>
		${video.textContent}`;
}
function clickHandler (event) {

  let link = event.target.closest('[data-youtube]');
  if (!link) return;
  event.preventDefault();
  let id = link.getAttribute('data-youtube');
  let player = document.createElement('div');
  player.innerHTML = `<div class="ratio ratio-16x9 mt-4"><iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
  link.replaceWith(player);
}
document.addEventListener('click', clickHandler);

// lazy
// lazy images
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.lazy');
  const lazyBackgrounds = [].slice.call(
    document.querySelectorAll('.lazy-background')
  );

  if (!('IntersectionObserver' in window)) {
    images.forEach(image => {
      handleImage(image);
    });
    $('.lazy-background').each(function() {
      const s = $(this).attr('style');
      const y = s.replace('_preload', '');
      $(this).attr('style', y);
    });
  } else {
    // BG
    const lazyBackgroundObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // entry.target.classList.add('visible');
            const x = entry.target.style.backgroundImage;
            const y = x.replace('_preload', '');
            entry.target.style.backgroundImage = y;

            lazyBackgroundObserver.unobserve(entry.target);
          }
        });
      }
    );

    lazyBackgrounds.forEach(lazyBackground => {
      lazyBackgroundObserver.observe(lazyBackground);
    });

    const config = {
      rootMargin: '300px 0px',
      threshold: 0.01,
    };
    const observer = new IntersectionObserver(observeImages, config);

    images.forEach(image => {
      observer.observe(image);
    });

    function observeImages(entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          observer.unobserve(entry.target);
          handleImage(entry.target);
        }
      });
    }
  }
});

function handleImage(el) {
  preloadImage(el.dataset.src).then(src => {
    el.tagName === 'IMG' ?
      el.src = src :
      el.style.backgroundImage = 'url('+ src +')';
    el.classList.add('faded');
    el.removeAttribute('data-src');
  })
}

function preloadImage(url) {
  return new Promise((resolve,reject) => {
    let image = new Image();
    image.load = resolve(url);
    image.error = reject;
    image.src = url;
  })
}

// Barrierefreiheit: Kontrast-Toggle
document.addEventListener('DOMContentLoaded', () => {
  const contrastToggle = document.getElementById('contrast-toggle');
  if (!contrastToggle) return;

  // Zustand aus localStorage laden
  const isHighContrast = localStorage.getItem('highContrast') === 'true';
  if (isHighContrast) {
    document.body.classList.add('high-contrast');
    contrastToggle.setAttribute('aria-pressed', 'true');
    contrastToggle.setAttribute('aria-label', 'Hohen Kontrast deaktivieren');
  }

  contrastToggle.addEventListener('click', () => {
    const isActive = document.body.classList.toggle('high-contrast');
    contrastToggle.setAttribute('aria-pressed', isActive);
    contrastToggle.setAttribute('aria-label', isActive ? 'Hohen Kontrast deaktivieren' : 'Hohen Kontrast aktivieren');
    localStorage.setItem('highContrast', isActive);
  });
});

// Barrierefreiheit: Accordion aria-expanded Toggle
document.querySelectorAll('[id^="question"]').forEach(function(button) {
  button.addEventListener('click', function() {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    // Alle schließen
    document.querySelectorAll('[id^="question"]').forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    // Aktuelles öffnen/schließen
    this.setAttribute('aria-expanded', !isExpanded);
  });
});

// Barrierefreiheit: Slider Accessibility
document.addEventListener('DOMContentLoaded', () => {
  // Alle Swiper-Container finden
  const swiperContainers = document.querySelectorAll('.swiper-container');

  swiperContainers.forEach((container, containerIndex) => {
    // ARIA-Rolle für Slider
    container.setAttribute('role', 'region');
    container.setAttribute('aria-roledescription', 'Karussell');
    container.setAttribute('aria-label', 'Bildkarussell ' + (containerIndex + 1));

    // Pagination Bullets mit aria-labels versehen
    const bullets = container.querySelectorAll('.swiper-pagination-bullet');
    bullets.forEach((bullet, index) => {
      bullet.setAttribute('role', 'button');
      bullet.setAttribute('aria-label', 'Gehe zu Slide ' + (index + 1) + ' von ' + bullets.length);
    });

    // Slides mit aria-labels versehen
    const slides = container.querySelectorAll('.swiper-slide');
    slides.forEach((slide, index) => {
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'Slide');
      slide.setAttribute('aria-label', 'Slide ' + (index + 1) + ' von ' + slides.length);
    });

    // Autoplay bei Hover/Focus pausieren
    container.addEventListener('mouseenter', () => {
      const swiper = container.swiper;
      if (swiper && swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    });

    container.addEventListener('mouseleave', () => {
      const swiper = container.swiper;
      if (swiper && swiper.autoplay && swiper.params.autoplay) {
        swiper.autoplay.start();
      }
    });

    container.addEventListener('focusin', () => {
      const swiper = container.swiper;
      if (swiper && swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    });

    container.addEventListener('focusout', (e) => {
      if (!container.contains(e.relatedTarget)) {
        const swiper = container.swiper;
        if (swiper && swiper.autoplay && swiper.params.autoplay) {
          swiper.autoplay.start();
        }
      }
    });

    // Tastatur-Navigation
    container.addEventListener('keydown', (e) => {
      const swiper = container.swiper;
      if (!swiper) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        swiper.slidePrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        swiper.slideNext();
      }
    });

    // Tabindex für Tastatur-Fokus
    container.setAttribute('tabindex', '0');
  });
});
